module.exports = __webpack_public_path__ + "img/191.missing_toiletries.f7cb5fe2.svg";